import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import './SkeletonLoader.css';

// Base skeleton element
const Skeleton = ({ width, height, borderRadius = '4px', className = '' }) => (
  <div 
    className={`skeleton-box ${className}`}
    style={{ 
      width: width || '100%', 
      height: height || '20px',
      borderRadius 
    }}
  />
);

// Product Card Skeleton
export const ProductCardSkeleton = () => (
  <Card className="h-100 border-0 shadow-sm">
    <Skeleton height="200px" borderRadius="8px 8px 0 0" />
    <Card.Body>
      <Skeleton width="60%" height="14px" className="mb-2" />
      <Skeleton width="90%" height="20px" className="mb-2" />
      <Skeleton width="100%" height="14px" className="mb-1" />
      <Skeleton width="80%" height="14px" className="mb-3" />
      <div className="d-flex justify-content-between align-items-center">
        <Skeleton width="80px" height="24px" />
        <Skeleton width="100px" height="36px" borderRadius="20px" />
      </div>
    </Card.Body>
  </Card>
);

// Product Grid Skeleton
export const ProductGridSkeleton = ({ count = 8 }) => (
  <Row>
    {[...Array(count)].map((_, index) => (
      <Col key={index} lg={3} md={4} sm={6} className="mb-4">
        <ProductCardSkeleton />
      </Col>
    ))}
  </Row>
);

// Product Detail Skeleton
export const ProductDetailSkeleton = () => (
  <Row>
    <Col lg={6}>
      <Skeleton height="400px" borderRadius="8px" className="mb-3" />
      <div className="d-flex gap-2">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} width="80px" height="80px" borderRadius="8px" />
        ))}
      </div>
    </Col>
    <Col lg={6}>
      <Skeleton width="40%" height="16px" className="mb-2" />
      <Skeleton width="80%" height="32px" className="mb-3" />
      <Skeleton width="100%" height="16px" className="mb-1" />
      <Skeleton width="90%" height="16px" className="mb-1" />
      <Skeleton width="70%" height="16px" className="mb-4" />
      <Skeleton width="120px" height="36px" className="mb-4" />
      <Skeleton width="100%" height="48px" borderRadius="8px" />
    </Col>
  </Row>
);

// Table Row Skeleton
export const TableRowSkeleton = ({ columns = 5 }) => (
  <tr>
    {[...Array(columns)].map((_, index) => (
      <td key={index}>
        <Skeleton height="20px" />
      </td>
    ))}
  </tr>
);

// List Item Skeleton
export const ListItemSkeleton = () => (
  <div className="d-flex align-items-center p-3 border-bottom">
    <Skeleton width="50px" height="50px" borderRadius="50%" className="me-3" />
    <div className="flex-grow-1">
      <Skeleton width="60%" height="16px" className="mb-2" />
      <Skeleton width="40%" height="14px" />
    </div>
  </div>
);

// Review Skeleton
export const ReviewSkeleton = () => (
  <Card className="mb-3 border-0 shadow-sm">
    <Card.Body>
      <div className="d-flex align-items-center mb-3">
        <Skeleton width="40px" height="40px" borderRadius="50%" className="me-3" />
        <div>
          <Skeleton width="120px" height="16px" className="mb-1" />
          <Skeleton width="80px" height="14px" />
        </div>
      </div>
      <Skeleton width="100px" height="16px" className="mb-2" />
      <Skeleton width="100%" height="14px" className="mb-1" />
      <Skeleton width="90%" height="14px" className="mb-1" />
      <Skeleton width="60%" height="14px" />
    </Card.Body>
  </Card>
);

export default Skeleton;
